import React from 'react'
import { fetchZhuanquAddGoods } from '../../../../../api/recommendGoods'
import {
  Form,
  Input,
  Modal,
  Select,
  message,
  Upload,
  Button,
  Icon,
  Radio,
} from 'antd'
import { upload_token } from '../../../../../utils/token'
import './index.scss'
const formItemLayout = {
  labelCol: {
    xs: { span: 8 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 40 },
    sm: { span: 20 },
  },
}
const { Option } = Select
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
class EditGoodsModal extends React.Component {
  state = {
    loading: false,
    img: '',
    token: upload_token(),
    previewVisible: false,
    type: 0,
    exampleVisible: false,
  }
  componentDidMount() {
    this.props.onRef(this)
  }
  handlePreview = async (file) => {
    this.setState({
      previewVisible: true,
    })
  }
  handleOk = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let data = { ...values }
        data.img = this.state.img
        data.id = this.props.currentGoods.id
        switch (data.type) {
          case 1:
            data.password = ''
            break
          case 2:
            data.path = ''
            data.appid = ''
            break
          default:
            break
        }
        fetchZhuanquAddGoods(data).then((res) => {
          if (res.success) {
            message.success('新增成功')
            this.props.handleCancel()
            this.props.getList()
          }
        })
      }
    })
  }
  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true })
      return
    }
    if (info.file.status === 'done') {
      this.setState({
        img: 'http://qiniu-retail.ieou.com/' + info.file.response.key,
        loading: false,
      })
    }
  }
  normFile = (e) => {
    console.log('Upload event:', e)
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }
  setImg = (value) => {
    this.setState({
      img: value,
    })
  }
  handleRemove = () => {
    this.setState({
      img: '',
    })
  }
  componentDidUpdate() {
    if (this.props.currentGoods.type && !this.state.type) {
      this.setState({
        type: this.props.currentGoods.type,
      })
    }
  }
  typeChange = (e) => {
    console.log(e)
    this.setState({
      type: e.target.value,
    })
  }
  showExample = () => {
    this.setState({
      exampleVisible: true,
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const { visible, handleCancel, currentGoods } = this.props
    const { img, token, previewVisible, type, loading, exampleVisible } =
      this.state
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className='ant-upload-text'>上传图片</div>
      </div>
    )
    return (
      <Modal
        className='zhuanModal'
        destroyOnClose={true}
        title={currentGoods.id ? '添加商品' : '编辑商品'}
        visible={visible}
        width={700}
        onOk={this.handleOk}
        onCancel={() => {
          handleCancel()
          setTimeout(() => {
            this.setState({
              type: 0,
            })
          }, 200)
        }}>
        <Form
          onSubmit={this.handleOk}
          style={{ width: '70%' }}
          {...formItemLayout}>
          <Form.Item style={{ position: 'relative' }} label='商品名称'>
            {getFieldDecorator('name', {
              initialValue: currentGoods.name,
              rules: [{ required: true, message: '请输入商品名称' }],
            })(<Input placeholder='请输入商品名称' />)}
            <a onClick={this.showExample} className='example'>
              显示示例
            </a>
          </Form.Item>
          <Form.Item label='市场价'>
            {getFieldDecorator('marketPrice', {
              initialValue: currentGoods.marketPrice,
              rules: [
                { required: true, message: '请输入市场价' },
                {
                  type: 'number',
                  min: 0,
                  message: '请输入正确的价格',
                  transform(value) {
                    if (value) {
                      return Number(value)
                    }
                  },
                },
              ],
            })(<Input placeholder='请输入市场价' suffix='元' />)}
          </Form.Item>
          <Form.Item label='优惠价'>
            {getFieldDecorator('discountPrice', {
              initialValue: currentGoods.discountPrice,
              rules: [
                { required: true, message: '请输入优惠价' },
                {
                  type: 'number',
                  min: 0,
                  message: '请输入正确的价格',
                  transform(value) {
                    if (value) {
                      return Number(value)
                    }
                  },
                },
              ],
            })(<Input placeholder='请输入优惠价' suffix='元' />)}
          </Form.Item>
          <Form.Item
            label='上传图片'
            extra='图片仅支持jpg，jpeg，png格式
                建议图片尺寸为702*320px'>
            {getFieldDecorator('img', {
              valuePropName: 'fileList',
              getValueFromEvent: this.normFile,
              rules: [{ required: true, message: '请上传图片' }],
              initialValue: currentGoods.img
                ? [
                    {
                      url: currentGoods.img,
                      uid: 0,
                    },
                  ]
                : [],
            })(
              <Upload
                name='file'
                listType='picture-card'
                className='avatar-uploader'
                showUploadList={true}
                action='https://upload.qiniup.com/'
                data={{
                  token: token,
                  key: new Date().getTime() + '@image',
                }}
                accept='image/*'
                onPreview={this.handlePreview}
                onChange={this.handleChange}
                onRemove={this.handleRemove}>
                {img || loading ? null : uploadButton}
              </Upload>
            )}
          </Form.Item>
          <Form.Item label='跳转方式'>
            {getFieldDecorator('type', {
              initialValue: currentGoods.type,
              rules: [{ required: true, message: '请输入跳转方式' }],
            })(
              <Radio.Group onChange={this.typeChange}>
                <Radio value={1}>小程序</Radio>
                <Radio value={2}>口令复制</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          {type == 1 ? (
            <>
              {' '}
              <Form.Item label='APPID'>
                {getFieldDecorator('appid', {
                  initialValue: currentGoods.appid,
                  rules: [{ required: true, message: '请输入APPID' }],
                })(<Input placeholder='请输入APPID' />)}
              </Form.Item>
              <Form.Item label='路径'>
                {getFieldDecorator('path', {
                  initialValue: currentGoods.path,
                  rules: [{ required: true, message: '请输入路径' }],
                })(<Input placeholder='请输入路径' />)}
              </Form.Item>
            </>
          ) : null}
          {type == 2 ? (
            <Form.Item label='口令'>
              {getFieldDecorator('password', {
                initialValue: currentGoods.password,
                rules: [{ required: true, message: '请输入口令' }],
              })(<Input placeholder='请输入口令' />)}
            </Form.Item>
          ) : null}
        </Form>
        <Modal
          title='显示示例'
          width={700}
          visible={exampleVisible}
          footer={null}
          onCancel={() => {
            this.setState({
              exampleVisible: false,
            })
          }}>
          <img
            style={{ margin: '0 auto', display: 'block' }}
            src={require('../../../../../assets/images/example.png')}></img>
        </Modal>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={() =>
            this.setState({
              previewVisible: false,
            })
          }>
          <img alt='example' style={{ width: '100%' }} src={img} />
        </Modal>
      </Modal>
    )
  }
}

export default Form.create()(EditGoodsModal)
